import { ChevronRight } from 'lucide-react'
import { Link } from 'react-router-dom'
import { Tooltip } from '../components/Tooltip.tsx'
import type { Me } from '../types.ts'
import { AppMark, itemName } from '../ui.tsx'

/** The MCP servers, as the person stands with each: the ones they can use first, each opening
 *  how to add it to Claude, then the rest dimmed, saying why on hover. */
export function McpServers({ me }: { me: Me }) {
  const { mcpServers, otherMcpServers } = me.current!
  return (
    <section>
      <div className="section-head">
        <div>
          <h1>MCP Servers</h1>
          <p className="muted">Let your AI agents connect to your tools</p>
        </div>
      </div>
      {mcpServers.length === 0 && otherMcpServers.length === 0 ? (
        <p className="muted">There are no MCP servers yet.</p>
      ) : (
        <ul className="list-rows card-list license-list">
          {mcpServers.map((server) => (
            <li key={server.appId}>
              <Link className="license-row license-link" to={server.appId}>
                <span className="license-name">
                  <AppMark appId={server.appId} name={server.name} kind="mcp" size={56} />
                  <span className="license-text">
                    <strong>{itemName({ name: server.name, kind: 'mcp' })}</strong>
                    <span className="muted small">See how to add it to Claude</span>
                  </span>
                </span>
                <ChevronRight className="row-chevron" aria-hidden="true" />
              </Link>
            </li>
          ))}
          {otherMcpServers.map((server) => (
            <li key={server.appId} className="license-off">
              <span className="license-row">
                <Tooltip
                  placement="right"
                  text={
                    server.companyHas
                      ? `Your company has ${server.name}, but you haven't been given it. Ask your company's administrator.`
                      : `Your company doesn't have ${server.name}. Contact Icefield AI to add it.`
                  }
                >
                  <span className="license-name">
                    <AppMark appId={server.appId} name={server.name} kind="mcp" size={56} />
                    <span className="license-text">
                      <strong>{itemName({ name: server.name, kind: 'mcp' })}</strong>
                      <span className="muted small">{server.companyHas ? 'Not given to you' : 'Not included'}</span>
                    </span>
                  </span>
                </Tooltip>
              </span>
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}
